import * as actionTypes from '../../config/actionTypes';

const initialState = {
    events: {},
    units: {},
    initiated: false,
    submitted: false,
};

export default function simplyBook(state, action = {}) {
    if (typeof state === 'undefined') {
        return initialState;
    }

    const reducers = {
        [actionTypes.RECEIVED_ACCESS_TOKEN]: () => ({
            ...state,
            initiated: true,
        }),
        [actionTypes.RECEIVED_UNIT_LIST]: () => {
            let units = { ...action.payload.units };

            Object.keys(units).forEach((key) => {
               units[key].displayName = units[key].name.split("|")[1];
               units[key].location = units[key].name.split("|")[0];
            });

            return {
                ...state,
                units: units
            }
        },
        [actionTypes.RECEIVED_EVENT_LIST]: () => {
            return {
                ...state,
                events: action.payload.events
            }
        },
        [actionTypes.CHECKING_AVAILIBILITY]: () => {
            return {
                ...state,
                checkingAvailability: true
            }
        },
        [actionTypes.PREPARE_BOOKING]: () => {
          return {
              ...state,
              newEvent: {
                  availability: action.payload.availability,
                  event: action.payload.event
              }
          }
        },
        [actionTypes.RESET_EVENT_BOOKING]: () => {
            return {
                ...state,
                newEvent: {}
            }
        },
        ['DELETE_CUSTOMER']: () => ({
            ...initialState,
        }),

        ['SUBMIT_CUSTOMER']: () => ({
            ...state,
            submitted: true,
        }),

        ['UPDATE_CUSTOMER']: () => ({
            ...state,
            ...action.data,
        }),
    };


    return reducers[action.type] ? reducers[action.type]() : state;
}


// WEBPACK FOOTER //
// ./src/store/reducers/simplyBook.js